import React, { Component } from 'react'

import PlusMinus from '../PlusMinus/'
import { Box, BoxHeader, BoxContent, BoxContentInner } from './styles'

class MobileToggler extends Component {

  constructor(props) {
    super(props)
    this.state = {
      boxActive: false
    }
  }

  toggleBox() {
    this.setState({ boxActive: ! this.state.boxActive })
  }

  render() {
    const { boxActive } = this.state

    return (
      <Box>

        <BoxHeader onClick={this.toggleBox.bind(this)}>
          <h2>{this.props.title}</h2>
          <PlusMinus active={boxActive} />
        </BoxHeader>

        <BoxContent active={boxActive}>
          <BoxContentInner>

            {this.props.children}

          </BoxContentInner>
        </BoxContent>

      </Box>
    )
  }
}

export default MobileToggler


// WEBPACK FOOTER //
// ./src/components/MobileToggler/index.js